import React from 'react';
import { Box, Typography, Link } from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import Button from '@mui/material/Button';

interface FooterProps {
  onChangelogClick?: () => void;
  themeMode?: 'light' | 'dark';
}

const Footer: React.FC<FooterProps> = ({ onChangelogClick, themeMode = 'light' }) => {
  const bgColor = themeMode === 'dark' ? '#fff' : '#0a3761';
  const textColor = themeMode === 'dark' ? '#0a3761' : '#fff';
  return (
    <>
      <Box
        component="footer"
        sx={{
          width: '100%',
          background: bgColor,
          color: textColor,
          py: 1.5,
          px: 2,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: 15,
          fontWeight: 500,
        }}
      >
        <Typography component="span" sx={{ fontWeight: 700, mr: 0.5, color: textColor }}>
          AutoUpgrade Composer
        </Typography>
        <Typography component="span" sx={{ mr: 0.5, color: textColor }}>
          v.26.3-2 -
        </Typography>
        <Link href="https://viniciusdba.com.br" target="_blank" rel="noopener" underline="hover" sx={{ color: textColor, fontWeight: 500, mx: 0.5 }}>
          https://viniciusdba.com.br
        </Link>
        <Typography component="span" sx={{ mx: 0.5, color: textColor }}>|</Typography>
        <Link
          underline="hover"
          sx={{ color: textColor, fontWeight: 500, mx: 0.5, cursor: 'pointer' }}
          onClick={e => {
            e.preventDefault();
            onChangelogClick && onChangelogClick();
          }}
        >
          Changelog
        </Link>
      </Box>
      <Box sx={{ width: '100%', textAlign: 'center', my: 1 }}>
        <Button
          variant="contained"
          color="primary"
          href="https://viniciusdba.com.br"
          target="_blank"
          rel="noopener"
          startIcon={<OpenInNewIcon />}
          sx={{
            fontWeight: 600,
            borderRadius: 3,
            px: 3,
            py: 1,
            fontSize: 15,
            boxShadow: 1,
            textTransform: 'none',
          }}
        >
          Visit My Blog
        </Button>
      </Box>
      <Box component="hr" sx={{ border: 0, borderTop: `1px solid ${textColor}`, opacity: 0.2, my: 1, width: '100%' }} />
      <Box sx={{ width: '100%', textAlign: 'center' }}>
        <Typography variant="caption" sx={{ color: textColor, opacity: 0.7, fontSize: 13, fontWeight: 400, display: 'inline', whiteSpace: 'nowrap', overflowX: 'auto' }}>
          <b>Disclaimer:</b> This tool is not supported or developed by Oracle Corporation, nor by my employer, Accenture. It is a personal project intended to help the Oracle community. Usage is free — no fees or costs. Always test before using. Feedback is welcome.
        </Typography>
      </Box>
      <Box component="hr" sx={{ border: 0, borderTop: `1px solid ${textColor}`, opacity: 0.2, my: 1, width: '100%' }} />
    </>
  );
};

export default Footer; 